import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'findByKey'
})
export class FindByKeyPipe implements PipeTransform {
  public transform<T>(array: T[], key: keyof T, search: any): T {
    if (!key || !search || !array) {
      return null;
    }
    return array.find((ar) => ar[key] === search);
  }
}
